import { useSeo } from "@/hooks/useSeo";
import { PageHero, CTABand } from "@/components/Layout";
import { ServiceCards, TrustBar } from "@/components/Sections";
import { business } from "@/data/site";

const Services = () => {
  useSeo({
    title: `Our Services — Plumbing, Electrical & HVAC in New York | ${business.name}`,
    description: "Explore our full range of New York home services: plumbing, electrical, and HVAC. Licensed, insured, 24/7 emergency response. Request a free estimate.",
  });
  return (
    <>
      <PageHero eyebrow="What We Do" title="Complete Home Services for New York" subtitle="Three specialties, one dependable team. Whatever your home needs, we've got the licensed pros to fix it right." />
      <TrustBar />
      <section className="max-w-7xl mx-auto px-4 py-16 sm:py-24" data-testid="services-list">
        <ServiceCards />
      </section>
      <CTABand />
    </>
  );
};

export default Services;
